import { render, staticRenderFns } from "./TabsNavigationItem.vue?vue&type=template&id=98dbf954&"
import script from "./TabsNavigationItem.vue?vue&type=script&lang=js&"
export * from "./TabsNavigationItem.vue?vue&type=script&lang=js&"
import style0 from "./TabsNavigationItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports